import React from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import { validateDate } from 'helpers/Utils.js';
import Box from '@bit/knotchinc.web-react-components.box';
import { TrialWindowContainer, DaysRemaining, TrialText } from './styled';

class BlueprintTrialWindow extends React.Component {
  render() {
    const { expirationDate } = this.props;
    if (!validateDate(expirationDate)) {
      return null;
    }

    const today = moment();
    const endDate = moment(expirationDate);
    const daysRemaning = endDate.diff(today, 'days');

    return (
      <TrialWindowContainer>
        <Box display="inline-block" verticalAlign="text-top">
          <DaysRemaining>{daysRemaning}</DaysRemaining>
          <TrialText>Days left in Free Trial</TrialText>
        </Box>
      </TrialWindowContainer>
    );
  }
}

const mapStateToProps = ({
  Account: {
    data: { blueprint_account },
  },
}) => ({ expirationDate: blueprint_account ? blueprint_account.expiration_date : null });

export default connect(mapStateToProps)(BlueprintTrialWindow);
